export default __webpack_public_path__ + "static/media/SetUpAccount.7c0e7b0c.jpg";